import { useContext } from 'react';
import { Redirect } from 'react-router-dom';
import { Container, Card, CardBody } from 'reactstrap';
import { Context as AuthContext } from '../../../contexts/AuthContext';

const TaskBoardRedirect = () => {
  const { user, currentSchool } = useContext(AuthContext);
  const schoolId = currentSchool?.value || user?.employee?.schoolId;

  if (schoolId) {
    return <Redirect to={`/task-board/${schoolId}`} />;
  }

  return (
    <Container fluid className="mt-4">
      <Card className="shadow">
        <CardBody>
          <p className="mb-0">
            We could not determine your school. Select a school in the app context or verify your assignment to a
            center.
          </p>
        </CardBody>
      </Card>
    </Container>
  );
};

export default TaskBoardRedirect;
